import { usePopupStore } from '@/stores/utils/popup';

export function popupBuilderWelcome() {
    usePopupStore().showPopup('custom', {
        cssClass: 'popup-type-1 condensed',
        showLanguageSwitch: true,
        showImage: true,
        title: {
            text: 'popups.dataset_instructions.title',
        },
        content: [
            {
                type: 'p',
                text: 'popups.dataset_instructions.description',
            },
            {
                type: 'ul',
                cssClass: 'list-ordered',
                items: [
                    {
                        text: 'popups.dataset_instructions.steps.1'
                    },
                    {
                        text: 'popups.dataset_instructions.steps.2'
                    },
                    {
                        text: 'popups.dataset_instructions.steps.3'
                    },
                    {
                        text: 'popups.dataset_instructions.steps.4'
                    },
                    {
                        text: 'popups.dataset_instructions.steps.5'
                    }
                ]
            },
            {
                type: 'p',
                text: 'popups.dataset_instructions.notice'
            },
        ],
        buttons: [
            {
                text: 'popups.dataset_instructions.button_confirm',
                cssClass: 'btn-1 btn-m'
            }
        ]
    });
}

export function popupBuilderDatasetLoaded(name = null, restoreFn = null) {
    if(restoreFn && typeof restoreFn === 'function') {
        usePopupStore().showPopup('custom', {
            cssClass: 'popup-type-1 condensed',
            showLanguageSwitch: true,
            showImage: true,
            title: {
                text: name ? 'popups.dataset_loaded.title_alt' : 'popups.dataset_loaded.title',
                i18n: { name: name }
            },
            content: [
                {
                    type: 'p',
                    text: name ? 'popups.dataset_loaded.description_alt' : 'popups.dataset_loaded.description',
                    i18n: { name: name }
                },
                {
                    type: 'ul',
                    cssClass: 'list-ordered',
                    items: [
                        {
                            text: 'popups.dataset_instructions.steps.1'
                        },
                        {
                            text: 'popups.dataset_instructions.steps.2'
                        },
                        {
                            text: 'popups.dataset_instructions.steps.3'
                        },
                        {
                            text: 'popups.dataset_instructions.steps.4'
                        },
                        {
                            text: 'popups.dataset_instructions.steps.5'
                        }
                    ]
                },
                {
                    type: 'p',
                    text: name ? 'popups.dataset_loaded.notice_backup_alt' : 'popups.dataset_loaded.notice_backup',
                    i18n: { name: name }
                }
            ],
            buttons: [
                {
                    text: 'popups.dataset_loaded.button_confirm',
                    cssClass: 'btn-1 btn-m'
                },
                {
                    text: 'popups.dataset_loaded.button_restore',
                    cssClass: 'btn-4 btn-m',
                    fn: restoreFn
                }
            ]
        });
    } else {
        usePopupStore().showPopup('custom', {
            cssClass: 'popup-type-1 condensed',
            showLanguageSwitch: true,
            showImage: true,
            title: {
                text: name ? 'popups.dataset_loaded.title_alt' : 'popups.dataset_loaded.title',
                i18n: { name: name }
            },
            content: [
                {
                    type: 'p',
                    text: name ? 'popups.dataset_loaded.description_alt' : 'popups.dataset_loaded.description',
                    i18n: { name: name }
                },
                {
                    type: 'ul',
                    cssClass: 'list-ordered',
                    items: [
                        {
                            text: 'popups.dataset_instructions.steps.1'
                        },
                        {
                            text: 'popups.dataset_instructions.steps.2'
                        },
                        {
                            text: 'popups.dataset_instructions.steps.3'
                        },
                        {
                            text: 'popups.dataset_instructions.steps.4'
                        },
                        {
                            text: 'popups.dataset_instructions.steps.5'
                        }
                    ]
                },
                {
                    type: 'p',
                    text: 'popups.dataset_loaded.notice'
                },
            ],
            buttons: [
                {
                    text: 'popups.dataset_loaded.button_confirm',
                    cssClass: 'btn-1 btn-m'
                }
            ]
        });
    }
}